import * as React from "react";
import { StandardProps } from "@material-ui/core";
import MuiTable, {
    TableBaseProps as MuiTableBaseProps,
    TableClassKey as MuiTableClassKey,
    Padding as MuiPadding
} from "@material-ui/core/Table";

export type TableBaseProps = MuiTableBaseProps;
export type TableClassKey = MuiTableClassKey;
export type Padding = MuiPadding;

export interface TableProps extends StandardProps<TableBaseProps, TableClassKey> {
    component?: React.ReactType<TableBaseProps>;
    padding?: Padding;
}

class Table extends React.Component<TableProps>{

    render() {
        const { ...props } = this.props;
        return <MuiTable {...props}>
            {this.props.children}
        </MuiTable>
    }
}

export default Table;